export default __webpack_public_path__ + "static/media/foto.2c9aa492.png";